import React from 'react';

/**
 * Placeholder for a content element that is being loaded.
 * Shows an element with a title and, below it, a form where each cell contains a loading bar element.
 */
export default function ContentLoadPlaceholder() {
    return (
        <div className="ph-item">
            <div className="ph-col-12">
                <div className="ph-row">
                    <div className="ph-col-2 ph-col-sm-6 bigger"></div>
                    <div className="ph-col-10 ph-col-sm-6 empty"></div>
                </div>
                <div className="ph-row">
                    <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-small"></div>
                    <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-small"></div>
                </div>
                <div className="ph-row">
                    <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-medium"></div>
                    <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-medium"></div>
                </div>
                <div className="ph-row">
                    <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-medium"></div>
                    <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-medium"></div>
                </div>
                <div className="ph-row ph-row-sm-hide">
                    <div className="ph-col-6 extra-big equal-sizes margin-top-medium"></div>
                    <div className="ph-col-6 extra-big equal-sizes margin-top-medium"></div>
                </div>
            </div>
        </div>
    )
}